import axios from "./axios"; // Import the centralized Axios instance
import prm from "./prm";

const state = {
  tables: [],
};

const getters = {
  allTables: (state) => state.tables,
};

const actions = {
  async fetchTables({ commit }, params = {}) {
    try {
      const response = await axios.get("/table", {
        params: prm(params),
      });

      commit("setTables", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch tables:", error);
    }
  },
  async createTable({ commit }, table) {
    try {
      const response = await axios.post("/table", table);
      commit("addTable", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to create table:", error);
      throw error;
    }
  },
  async fetchTableById(_, id) {
    try {
      const response = await axios.get(`/table/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch table:", error);
      throw error;
    }
  },
  async updateTable({ commit }, table) {
    try {
      const response = await axios.put(`/table/${table.id}`, table);
      commit("updateTable", response.data);
    } catch (error) {
      console.error("Failed to update table:", error);
      throw error;
    }
  },
  async deleteTableById({ commit }, id) {
    try {
      const response = await axios.delete(`/table/${id}`);
      commit("removeTable", id);
      return response.data;
    } catch (error) {
      console.error("Failed to delete table:", error);
      throw error;
    }
  },
};

const mutations = {
  setTables(state, tables) {
    state.tables = [...tables.data]; // Ensure this matches your API's response structure
  },
  addTable(state, table) {
    state.tables.unshift(table);
  },
  updateTable(state, updatedTable) {
    const index = state.tables.findIndex(
      (table) => table.id === updatedTable.id
    );
    if (index !== -1) {
      state.tables.splice(index, 1, updatedTable);
    }
  },
  removeTable(state, id) {
    console.log("REMOVE TABLE: ", id);
    state.tables = state.tables.filter((table) => table.id != id);

    console.log("STATE TABLES: ", state.tables);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
